module.exports = __webpack_public_path__ + "img/parasites-1.65669fd0.png";